import { toContactLensesBundleCartLineItem } from './contact-lenses-bundle-line-item.js';
import { toGlassesBundleCartLineItem } from './glasses-bundle-line-item.js';
import { toNonPrescriptionBundleCartLineItem } from './non-prescription-bundle-line-item.js';
import '@grandvisionhq/utils';
import { isPrescriptionGlassesTypeDetails, isNonPrescriptionBundleTypeDetails, isContactLensBundleTypeDetails } from './utils/cart-line-item-product-type-guards.js';

const toBundleCartLineItem = (lineItem, intl, settings, apiUrl)=>{
    if (lineItem.typeDetails && isPrescriptionGlassesTypeDetails(lineItem.typeDetails)) {
        return toGlassesBundleCartLineItem(lineItem, lineItem.typeDetails, intl, settings, apiUrl);
    }
    if (lineItem.typeDetails && isNonPrescriptionBundleTypeDetails(lineItem.typeDetails)) {
        return toNonPrescriptionBundleCartLineItem(lineItem, intl, settings);
    }
    if (lineItem.typeDetails && isContactLensBundleTypeDetails(lineItem.typeDetails)) {
        return toContactLensesBundleCartLineItem(lineItem, intl, settings);
    }
};

export { toBundleCartLineItem };
//# sourceMappingURL=bundle-cart-line-item.js.map
